<template>
  <div>
    <el-card class="box-card">
      <!-- 搜索区域 -->
      <div style="margin-bottom: 20px;">
        <el-form :inline="true" size="small" label-width="80px">
          <el-form-item label="运营商:">
            <el-select v-model="queryReq.distributorId" clearable placeholder="全部" style="width: 200px;" @change="reGetList">
              <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡类型:">
            <el-select v-model="queryReq.cardType" clearable placeholder="全部" style="width: 120px;" @change="reGetList">
              <el-option label="日卡" :value="1"></el-option>
              <el-option label="周卡" :value="2"></el-option>
              <el-option label="月卡" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="queryReq.status" clearable placeholder="全部" style="width: 120px;" @change="reGetList">
              <el-option label="待支付" :value="0"></el-option>
              <el-option label="有效" :value="1"></el-option>
              <el-option label="已过期" :value="2"></el-option>
              <el-option label="已退款" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reGetList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="cardList" border stripe :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="卡券名称" prop="cardName"></el-table-column>
        <el-table-column label="卡类型">
          <template slot-scope="scope">
            <el-tag :type="cardTypeTag(scope.row.cardType)">{{ cardTypeText(scope.row.cardType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户">
          <template slot-scope="scope">
            <div>{{ scope.row.memberName || '-' }}</div>
            <div style="font-size: 12px; color: #999;">{{ scope.row.mobile || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="运营商" prop="distributorName"></el-table-column>
        <el-table-column label="卡价格" prop="price"></el-table-column>
        <el-table-column label="保险金额">
          <template slot-scope="scope">
            {{ scope.row.insuranceAmount > 0 ? '¥' + scope.row.insuranceAmount : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="支付渠道">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.payChannel == 2 ? 'warning' : ''">
              {{ scope.row.payChannel == 2 ? '银联' : '微信' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="生效时间" prop="startTime">
          <template slot-scope="scope">{{ formatTime(scope.row.startTime) }}</template>
        </el-table-column>
        <el-table-column label="到期时间" prop="endTime">
          <template slot-scope="scope">{{ formatTime(scope.row.endTime) }}</template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="small">{{ statusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="购买时间" prop="createTime">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
            <!-- <el-button size="mini" type="danger" icon="el-icon-delete"
                       :disabled="scope.row.status === 1"
                       :title="scope.row.status === 1 ? '有效卡券不可直接删除，请先标记为已退款或已过期' : ''"
                       @click="deleteCard(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryReq.page" :page-sizes="[8, 15, 25, 50]"
        :page-size="queryReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑卡券" :visible.sync="dialogVisible" width="500px" @close="resetForm">
      <el-form :model="formData" :rules="formRules" ref="cardForm" label-width="100px" size="small">
        <el-form-item label="卡券名称">
          <span>{{ formData.cardName }}</span>
        </el-form-item>
        <el-form-item label="用户">
          <span>{{ formData.memberName }} {{ formData.mobile ? '(' + formData.mobile + ')' : '' }}</span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="formData.status" placeholder="请选择" style="width: 100%;">
            <el-option label="待支付" :value="0"></el-option>
            <el-option label="有效" :value="1"></el-option>
            <el-option label="已过期" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效时间" prop="startTime">
          <el-date-picker v-model="formData.startTime" type="datetime" placeholder="选择生效时间"
                          value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="到期时间" prop="endTime">
          <el-date-picker v-model="formData.endTime" type="datetime" placeholder="选择到期时间"
                          value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryReq: { page: 1, limit: 8, distributorId: '', cardType: null, status: null },
      cardList: [],
      total: 0,
      distributorOptions: [],
      dialogVisible: false,
      formData: {
        id: '', cardName: '', memberName: '', mobile: '',
        status: null, startTime: '', endTime: ''
      },
      formRules: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getDistributorOptions();
    this.getList();
  },
  methods: {
    async getDistributorOptions() {
      const { data: res } = await this.$http.get('/distributor/manager/getAllDistributorInfo');
      if (res.code == 200) this.distributorOptions = res.data;
    },
    async getList() {
      const { data: res } = await this.$http.get('/passCard/memberCards', { params: this.queryReq });
      if (res.code != 200) return this.$message.error(res.msg);
      this.cardList = res.data.list;
      this.total = res.data.total;
    },
    reGetList() { this.queryReq.page = 1; this.getList(); },
    handleSizeChange(val) { this.queryReq.limit = val; this.getList(); },
    handleCurrentChange(val) { this.queryReq.page = val; this.getList(); },
    cardTypeText(type) { return { 1: '日卡', 2: '周卡', 3: '月卡' }[type] || '-'; },
    cardTypeTag(type) { return { 1: '', 2: 'success', 3: 'warning' }[type] || ''; },
    statusText(status) { return { 0: '待支付', 1: '有效', 2: '已过期', 3: '已退款' }[status] || '-'; },
    statusTag(status) { return { 0: 'info', 1: 'success', 2: 'warning', 3: 'danger' }[status] || ''; },
    formatTime(time) {
      if (!time) return '-';
      if (typeof time === 'string') return time.replace('T', ' ').substring(0, 19);
      return time;
    },
    openEditDialog(row) {
      this.formData = {
        id: row.id,
        cardName: row.cardName,
        memberName: row.memberName,
        mobile: row.mobile,
        status: row.status,
        startTime: this.formatTime(row.startTime) === '-' ? null : this.formatTime(row.startTime),
        endTime: this.formatTime(row.endTime) === '-' ? null : this.formatTime(row.endTime)
      };
      this.dialogVisible = true;
    },
    resetForm() {
      this.formData = { id: '', cardName: '', memberName: '', mobile: '', status: null, startTime: '', endTime: '' };
      if (this.$refs.cardForm) this.$refs.cardForm.clearValidate();
    },
    submitForm() {
      this.$refs.cardForm.validate((valid) => {
        if (!valid) return;
        const data = { id: this.formData.id, status: this.formData.status };
        if (this.formData.startTime) data.startTime = this.formData.startTime;
        if (this.formData.endTime) data.endTime = this.formData.endTime;
        this.$http.post('/passCard/memberCard/update', data).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.dialogVisible = false;
          this.$message.success(res.data.msg);
          this.getList();
        });
      });
    },
    deleteCard(row) {
      const statusText = this.statusText(row.status);
      this.$confirm(`确定删除卡券「${row.cardName}」(状态: ${statusText})吗？删除后不可恢复。`, '警告', { type: 'warning' }).then(() => {
        this.$http.post('/passCard/memberCard/delete', null, { params: { id: row.id } }).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.$message.success(res.data.msg);
          this.reGetList();
        });
      }).catch(() => {});
    }
  }
}
</script>
